/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const PAUSE_VIEWBOX_W = 14;
const PAUSE_VIEWBOX_H = 20;

const PAUSE_PATH =
  'M11 0C10.2044 0 9.44129 0.316071 8.87868 0.87868C8.31607 1.44129 8 2.20435 8 3V17C8 17.7956 8.31607 18.5587 8.87868 19.1213C9.44129 19.6839 10.2044 20 11 20C11.7956 20 12.5587 19.6839 13.1213 19.1213C13.6839 18.5587 14 17.7956 14 17V3C14 2.20435 13.6839 1.44129 13.1213 0.87868C12.5587 0.316071 11.7956 0 11 0ZM12 17C12 17.2652 11.8946 17.5196 11.7071 17.7071C11.5196 17.8946 11.2652 18 11 18C10.7348 18 10.4804 17.8946 10.2929 17.7071C10.1054 17.5196 10 17.2652 10 17V3C10 2.73478 10.1054 2.48043 10.2929 2.29289C10.4804 2.10536 10.7348 2 11 2C11.2652 2 11.5196 2.10536 11.7071 2.29289C11.8946 2.48043 12 2.73478 12 3V17ZM3 0C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20C3.79565 20 4.55871 19.6839 5.12132 19.1213C5.68393 18.5587 6 17.7956 6 17V3C6 2.20435 5.68393 1.44129 5.12132 0.87868C4.55871 0.316071 3.79565 0 3 0ZM4 17C4 17.2652 3.89464 17.5196 3.70711 17.7071C3.51957 17.8946 3.26522 18 3 18C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2C3.26522 2 3.51957 2.10536 3.70711 2.29289C3.89464 2.48043 4 2.73478 4 3V17Z';

/** Default fill from Figma asset. */
export const PAUSE_ICON_DEFAULT_FILL = '#61677F';

const iconPropTypes = {
  size: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Pause (14×20). `size` sets rendered height; width scales to aspect ratio.
 * Color via `fill` or CSS `color` + `currentColor`.
 * Pass `aria-label` when icon conveys meaning without adjacent text.
 */
const PauseIcon = ({
  size = 20,
  fill = 'currentColor',
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  const height = size;
  const width = Math.round((size * PAUSE_VIEWBOX_W) / PAUSE_VIEWBOX_H);

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${PAUSE_VIEWBOX_W} ${PAUSE_VIEWBOX_H}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={['ds-icon', 'ds-icon--filled', className].filter(Boolean).join(' ')}
      aria-hidden={ariaLabel ? undefined : ariaHidden}
      aria-label={ariaLabel || undefined}
      role={ariaLabel ? 'img' : undefined}
      focusable="false"
      {...props}
    >
      <path d={PAUSE_PATH} fill={fill} />
    </svg>
  );
};

PauseIcon.propTypes = iconPropTypes;

export { PauseIcon };
export default PauseIcon;
